<template>
	<div id="ap">
		<a-layout>
			<div class="content-header">
				<a-affix :offset-top="0" style="width: 100%">
					<a-row type="flex" justify="space-between">
						<a-col span="12">
							<a-page-header title="套餐订单管理" @back="$router.back()"></a-page-header>
						</a-col>
						<a-col span="12">
							<a-row type="flex" align="middle" justify="end" :gutter="10">
								<a-col span="5">
									<a-input v-model="param.phone" allowClear search @pressEnter="getList" @on-clear="getList" placeholder="手机号查询"></a-input>
								</a-col>
								<a-col span="4">
									<a-select v-model="param.status" allowClear placeholder="订单状态" style="width: 100%" @change="getList">
										<a-select-option :value="-1">已取消</a-select-option>
										<a-select-option :value="0">待支付</a-select-option>
										<a-select-option :value="1">已完成</a-select-option>
									</a-select>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</a-affix>
			</div>
		</a-layout>

		<a-layout>
			<a-layout-content>
				<a-table :scroll="{ x: '100%' }" :pagination="false" :style="{ background: '#FFF' }" size="small" row-key="orderId" border :columns="keys" ref="list" :loading="loading" :data-source="data.records">
					<template slot-scope="row" slot="orderSn">
						{{ row.orderSn }}
					</template>
					<template slot-scope="row" slot="active">
						<a-space size="small">
							<a-image v-if="row.activeThumb" :width="40" :height="40" :src="row.activeThumb" />
							<span>{{ row.activeTitle }}</span>
						</a-space>
					</template>
					<template slot-scope="row" slot="price">
						<a-space direction="vertical" size="small">
							<span>数量：{{ row.number }}</span>
							<span style="color: #f5222d; font-weight: bold">￥{{ row.totalPrice }}</span>
						</a-space>
					</template>
					<template slot-scope="row" slot="user">
						<a-space direction="vertical" size="small">
							<span>{{ row.name }}</span>
							<span>{{ row.phone }}</span>
						</a-space>
					</template>
					<template slot-scope="row" slot="payStatus">
						<a-tag v-if="row.payStatus == '已支付'" color="green">已支付</a-tag>
						<a-tag v-else-if="row.payStatus == '未支付'" color="orange">未支付</a-tag>
						<a-tag v-else-if="row.payStatus == '已退款'" color="purple">已退款</a-tag>
						<a-tag v-else color="default">{{ row.payStatus }}</a-tag>
					</template>
					<template slot-scope="row" slot="status">
						<a-tag v-if="row.status == '已完成'" color="green">已完成</a-tag>
						<a-tag v-else-if="row.status == '待支付'" color="orange">待支付</a-tag>
						<a-tag v-else color="default">已取消</a-tag>
					</template>
					<template slot-scope="row" slot="refund">
						<span v-if="row.refundMoney" style="color: #722ed1">￥{{ row.refundMoney }}</span>
						<span v-else>-</span>
					</template>
					<template slot-scope="row" slot="action">
						<a-button-group shape="circle" size="small">
							<a-tooltip title="退款">
								<a-button type="link" icon="rollback" v-if="row.payStatus == '已支付'" @click="doRefund(row)"></a-button>
							</a-tooltip>
						</a-button-group>
					</template>
				</a-table>
			</a-layout-content>
		</a-layout>
		<a-row>
			<a-col span="12" offset="6" style="text-align: center; padding: 20px 0">
				<a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext" @showSizeChange="setLimit" :current="data.current" />
			</a-col>
		</a-row>
	</div>
</template>

<script>
import apiUtil from '@/common/apiUtil';
import utils from '@/common/utils';
export default {
	data() {
		return {
			loading: false,
			data: { records: [] },
			param: {
				page: 1,
				limit: 20,
				activeId: '',
				phone: '',
				status: ''
			},
			keys: [
				{ title: '订单号', scopedSlots: { customRender: 'orderSn' }, width: 180 },
				{ title: '套餐', scopedSlots: { customRender: 'active' }, width: 250 },
				{ title: '数量/金额', scopedSlots: { customRender: 'price' }, width: 120, align: 'center' },
				{ title: '购买人', scopedSlots: { customRender: 'user' }, width: 150 },
				{ title: '支付状态', scopedSlots: { customRender: 'payStatus' }, width: 100, align: 'center' },
				{ title: '退款金额', scopedSlots: { customRender: 'refund' }, width: 100, align: 'center' },
				{ title: '订单状态', scopedSlots: { customRender: 'status' }, width: 100, align: 'center' },
				{ title: '操作', scopedSlots: { customRender: 'action' }, width: 100, align: 'center' }
			]
		};
	},
	created() {
		this.param.activeId = this.$route.query.activeId ? parseInt(this.$route.query.activeId) : '';
		this.doRefresh();
	},
	methods: {
		getList() {
			this.loading = true;
			this.http
				.get('/platform/coupon/active/order/list', this.param)
				.then(ret => {
					this.data = ret.data;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		doRefund(row) {
			this.utils.confirm('确认对该订单进行退款？退款金额将按未核销券比例计算。').then(() => {
				utils.showSpin();
				this.http.post('/platform/coupon/active/order/refund', { orderId: row.orderId }).then(ret => {
					if (ret.code == 200) {
						this.utils.success('退款成功').then(() => {
							this.getList();
						});
					}
				});
			});
		},
		getNext(page, pageSize) {
			this.param.page = page;
			this.param.limit = pageSize;
			this.getList();
		},
		setLimit(current, size) {
			this.param.limit = size;
			this.param.page = 1;
			this.getList();
		},
		doRefresh() {
			this.param.page = 1;
			this.getList();
		}
	}
};
</script>

<style scoped>
#ap {
	padding: 15px;
}
</style>
